/*
同じ origin の /api/* (api-go) を呼ぶときの fetch。
アクセス用の JWT (session_token) は最長 60 分で切れる。クラウドエディターの頁は何時間も開いたままなので、途中から api-go が 401 を返す。
refresh Cookie はまだ生きていて、/api/auth/refresh で更新すれば通るのに、そのまま 401 の文を出すと
「ログインが切れています」という事実と違う知らせになる (入場券を取り直す「つなぎ直す」でも同じ)。
401 を受けたら 1 回だけ更新して撃ち直す。refresh Cookie が無い (本当に切れている) ときは、更新が 401 で返るだけで、元の 401 がそのまま返る。
ゲートウェイ (sandbox の origin) への要求には使わない。あちらの 401/403 は別の理由で、api-go の refresh では直らない。

shared-auth は呼ぶときに読み込む。progress.ts は手順の生成物の書き出し (bun run cloudeditor:guides、CI の一時の場所には node_modules が無い) からも
読み込まれるので、ここで静的に import すると、書き出しが依存を探して落ちる
*/
type AuthAwareFetch = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;

let wrapped: Promise<AuthAwareFetch> | null = null;

export const sessionFetch = (async (input: RequestInfo | URL, init?: RequestInit) => {
  wrapped ??= import("@noiman/shared-auth").then((m) => m.createAuthAwareFetch());
  return (await wrapped)(input, init);
}) as typeof fetch;
